import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Redirect.scss'
import error from '../../error.gif'

function Cancel() {
    return (
        <div id='redirectMessage'>
            <div className='messageContainer'>
                <img className='responseLogo' src={error} alt="error" />
                <h1 className='responseHeader'>This transaction has been canceled.</h1>
                <p className='responseText'>If you are unsure why this error occured, please contact us <a href="#chatraChatExpanded">here</a>.</p>
            </div>
        </div>
    )
}

export default Cancel
